import axios from "axios";

const endpoint =
  process.env.NODE_ENV === "development"
    ? "https://localhost:44317/api/"
    : "https://homologapi.appdoit.com.br/api/";

const http = axios.create({
  baseURL: endpoint,
});

http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error.response.status);
    return Promise.reject(error);
  }
);

export default http;
